import {
  TEntityResponse,
  TEntityListResponse,
  TCreateRoleReqBody,
  TRoleResBody,
  TRoleSummaryResBody,
  TUpdateRoleReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TRolesClient = {
  create(body: TCreateRoleReqBody): Promise<TEntityResponse<'role', TRoleResBody> | undefined>;
  update(id: string, body: TUpdateRoleReqBody): Promise<TEntityResponse<'role', TRoleResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'role', TRoleResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'role', TRoleSummaryResBody> | undefined>;
};

function RolesClient(apiClient: TAPIClient): TRolesClient {
  return {
    async create(body: TCreateRoleReqBody): Promise<TEntityResponse<'role', TRoleResBody> | undefined> {
      const data = await apiClient.post<TCreateRoleReqBody, TEntityResponse<'role', TRoleResBody>>('/roles', body);

      if (data && data.type !== 'role') {
        throw new Error('Invalid entity type received, expected: role, received: ' + data.type);
      }

      return data;
    },

    async update(id: string, body: TUpdateRoleReqBody): Promise<TEntityResponse<'role', TRoleResBody> | undefined> {
      const data = await apiClient.put<TUpdateRoleReqBody, TEntityResponse<'role', TRoleResBody>>(`/roles/${id}`, body);

      if (data && data.type !== 'role') {
        throw new Error('Invalid entity type received, expected: role, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/roles/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'role', TRoleResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'role', TRoleResBody>>(`/roles/${id}`);

      if (data && data.type !== 'role') {
        throw new Error('Invalid entity type received, expected: role, received: ' + data.type);
      }

      return data;
    },

    async list(limit: number, page: number): Promise<TEntityListResponse<'role', TRoleSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'role', TRoleSummaryResBody>>(
        `/roles?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'role') {
        throw new Error('Invalid entity type received, expected: role, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TRolesClient, RolesClient };
